(function () {
  "use strict";
  var S = window.SaffronOro || {};
  function each(root, sel, fn) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var btn = document.getElementById("menu-btn"), nav = document.getElementById("mobile-nav");
    if (!btn || !nav || btn.dataset.ready) return;
    btn.dataset.ready = "1";
    function close() { nav.hidden = true; btn.setAttribute("aria-expanded", "false"); }
    btn.addEventListener("click", function () {
      var open = nav.hidden; nav.hidden = !open; btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    each(nav, "a", function (a) { a.addEventListener("click", close); });
    document.addEventListener("click", function (e) { if (!nav.hidden && !nav.contains(e.target) && !btn.contains(e.target)) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !nav.hidden) { close(); btn.focus(); } });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById("toast"); if (!t) return;
    t.textContent = msg; t.hidden = false; clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
  }

  /* ---------- Cart count ---------- */
  function setCount(n) {
    each(document, "[data-cart-count]", function (b) { b.textContent = n; b.hidden = n === 0; });
    var tpl = n === 1 ? S.strings.cartOne : S.strings.cartMany;
    each(document, ".cart-btn", function (b) { b.setAttribute("aria-label", tpl.replace("__N__", n)); });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = null, lastTrigger = null, closeTimer = null;
  function getDrawer() { drawer = document.getElementById("CartDrawer"); return drawer; }
  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
  }
  function openDrawer(trigger) {
    if (!getDrawer()) return false;
    lastTrigger = trigger || document.activeElement;
    clearTimeout(closeTimer);
    drawer.hidden = false;
    document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add("is-open"); }); });
    var panel = drawer.querySelector(".cart-drawer__panel");
    setTimeout(function () { var c = drawer.querySelector(".cart-drawer__close"); (c || panel).focus(); }, 60);
    return true;
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove("is-open");
    document.documentElement.style.overflow = "";
    closeTimer = setTimeout(function () { drawer.hidden = true; }, 360);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  function swapDrawer(sectionHtml) {
    if (!getDrawer() || !sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, "text/html");
    var fresh = doc.querySelector(".cart-drawer__inner"), current = drawer.querySelector(".cart-drawer__inner");
    if (fresh && current) {
      current.replaceWith(fresh);
      setCount(parseInt(fresh.getAttribute("data-count"), 10) || 0);
    }
  }
  function changeLine(line, qty, focusKey) {
    drawer.classList.add("is-busy");
    fetch(drawer.getAttribute("data-change-url") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty, sections: "cart-drawer" })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (cart) {
        swapDrawer(cart.sections && cart.sections["cart-drawer"]);
        var again = focusKey && drawer.querySelector(focusKey);
        (again || drawer.querySelector(".cart-drawer__close")).focus();
      })
      .catch(function (err) { toast((err && err.description) || S.strings.cartError); })
      .then(function () { drawer.classList.remove("is-busy"); });
  }
  function initDrawer() {
    if (!getDrawer() || drawer.dataset.ready) return;
    drawer.dataset.ready = "1";
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-drawer-close]")) { closeDrawer(); return; }
      var b = e.target.closest("button[data-line]");
      if (b) {
        var line = b.getAttribute("data-line"), qty = parseInt(b.getAttribute("data-qty"), 10);
        var key = qty > 0 ? 'button[data-line="' + line + '"][data-qty="' + b.getAttribute("data-qty") + '"]' : null;
        changeLine(parseInt(line, 10), Math.max(qty, 0), key);
      }
    });
    drawer.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeDrawer(); return; }
      if (e.key !== "Tab") return;
      var f = focusables(drawer.querySelector(".cart-drawer__panel")); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    if (!document.body.classList.contains("template-cart")) {
      each(document, ".cart-btn", function (a) {
        a.addEventListener("click", function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey) return;
          e.preventDefault(); openDrawer(a);
        });
      });
    }
  }

  /* ---------- AJAX add to cart ---------- */
  function initAjaxCart() {
    each(document, "form[data-ajax-cart]", function (form) {
      if (form.dataset.ready) return; form.dataset.ready = "1";
      form.addEventListener("submit", function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = form.querySelector("[type=submit]"); if (btn) btn.setAttribute("aria-disabled", "true");
        var data = new FormData(form);
        if (getDrawer()) data.append("sections", "cart-drawer");
        fetch(S.routes.cartAdd + ".js", { method: "POST", headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: data })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (res) {
            if (res.sections && res.sections["cart-drawer"]) { swapDrawer(res.sections["cart-drawer"]); openDrawer(btn); return; }
            return fetch(S.routes.cart + ".js", { headers: { "Accept": "application/json" } })
              .then(function (r) { return r.json(); })
              .then(function (cart) { setCount(cart.item_count); toast(S.strings.added); });
          })
          .catch(function (err) { toast((err && err.description) || S.strings.cartError); })
          .then(function () { if (btn) btn.removeAttribute("aria-disabled"); });
      });
    });
  }

  /* ---------- Product page: variants and gallery ---------- */
  function initProduct(root) {
    each(root, "[data-product]", function (p) {
      if (p.dataset.ready) return; p.dataset.ready = "1";
      var select = p.querySelector("[data-variant-select]"), price = p.querySelector("[data-price]"), btn = p.querySelector("[data-add-btn]");
      if (select) select.addEventListener("change", function () {
        var o = select.options[select.selectedIndex];
        if (price) price.innerHTML = o.getAttribute("data-price-html");
        if (btn) { var ok = o.getAttribute("data-available") === "true"; btn.disabled = !ok; btn.textContent = ok ? btn.getAttribute("data-label-add") : btn.getAttribute("data-label-soldout"); }
        var mid = o.getAttribute("data-media");
        if (mid) { var t = p.querySelector('.thumbs button[data-media-id="' + mid + '"]'); if (t) t.click(); }
      });
      var main = p.querySelector("[data-main-image]");
      each(p, ".thumbs button", function (b) {
        b.addEventListener("click", function () {
          if (!main) return;
          main.src = b.getAttribute("data-src"); main.removeAttribute("srcset"); main.alt = b.getAttribute("data-alt") || "";
          each(p, ".thumbs button", function (x) { x.setAttribute("aria-current", x === b ? "true" : "false"); });
        });
      });
    });
  }

  /* ---------- Hero carousel ---------- */
  function initHero(hero) {
    if (!hero || hero.dataset.ready) return; hero.dataset.ready = "1";
    var slides = Array.prototype.slice.call(hero.querySelectorAll(".slide"));
    var dotsWrap = hero.querySelector(".dots"), pauseBtn = hero.querySelector(".hero-pause");
    var L = hero.dataset;
    var current = 0, timer = null, hoverPaused = false;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var userPaused = reduce || L.autoplay === "false" || window.Shopify && window.Shopify.designMode;
    if (slides.length < 2) { var c = hero.querySelector(".hero-controls"); if (c) c.hidden = true; }
    var dots = slides.map(function (s, i) {
      var d = document.createElement("button");
      d.type = "button"; d.className = "dot"; d.innerHTML = "<span></span>";
      d.setAttribute("aria-label", L.goTo.replace("__N__", i + 1));
      d.addEventListener("click", function () { show(i); restart(); });
      dotsWrap.appendChild(d); return d;
    });
    slides.forEach(function (s, i) { s.setAttribute("aria-label", L.slideOf.replace("__N__", i + 1).replace("__T__", slides.length)); });
    function labelPause() {
      if (!pauseBtn) return;
      pauseBtn.setAttribute("aria-label", userPaused ? L.play : L.pause);
      pauseBtn.querySelector(".ic-pause").style.display = userPaused ? "none" : "";
      pauseBtn.querySelector(".ic-play").style.display = userPaused ? "" : "none";
    }
    function syncVideo() {
      slides.forEach(function (s, k) {
        var v = s.querySelector("video"); if (!v) return;
        if (k === current && !userPaused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); }
      });
    }
    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === current; s.classList.toggle("is-active", on);
        if (on) { s.removeAttribute("aria-hidden"); s.removeAttribute("inert"); } else { s.setAttribute("aria-hidden", "true"); s.setAttribute("inert", ""); }
      });
      dots.forEach(function (d, k) { d.setAttribute("aria-current", k === current ? "true" : "false"); });
      syncVideo();
    }
    function restart() {
      clearTimeout(timer);
      if (userPaused || hoverPaused || slides.length < 2) return;
      var ms = parseInt(slides[current].getAttribute("data-duration"), 10) || parseInt(L.interval, 10) || 7000;
      timer = setTimeout(function () { show(current + 1); restart(); }, ms);
    }
    hero.querySelector(".hero-prev").addEventListener("click", function () { show(current - 1); restart(); });
    hero.querySelector(".hero-next").addEventListener("click", function () { show(current + 1); restart(); });
    if (pauseBtn) pauseBtn.addEventListener("click", function () { userPaused = !userPaused; labelPause(); syncVideo(); restart(); });
    hero.addEventListener("mouseenter", function () { hoverPaused = true; restart(); });
    hero.addEventListener("mouseleave", function () { hoverPaused = false; restart(); });
    hero.addEventListener("focusin", function () { hoverPaused = true; restart(); });
    hero.addEventListener("focusout", function (e) { if (!hero.contains(e.relatedTarget)) { hoverPaused = false; restart(); } });
    var tx = null;
    hero.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener("touchend", function (e) {
      if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; tx = null;
      if (Math.abs(dx) > 40) { show(current + (dx < 0 ? 1 : -1)); restart(); }
    });
    hero._show = function (i) { show(i); };
    labelPause(); show(0); restart();
  }

  function initAll(root) {
    initMenu(); initDrawer(); initAjaxCart(); initProduct(root || document);
    each(root || document, "[data-hero]", initHero);
  }
  document.addEventListener("DOMContentLoaded", function () { initAll(document); });

  /* ---------- Theme editor support ---------- */
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:block:select", function (e) {
    var slide = e.target.closest && e.target.closest(".slide"); if (!slide) return;
    var hero = slide.closest("[data-hero]"); if (hero && hero._show) hero._show(Array.prototype.indexOf.call(hero.querySelectorAll(".slide"), slide));
  });
})();
